var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2762 15.8054L20.203 30.1731H16.4858L19.5593 15.8054H23.2762ZM38.9143 25.0828L40.8707 19.6874L41.9965 25.0828H38.9143ZM43.0629 30.1731H46.5L43.4973 15.8054H40.3268C39.6123 15.8054 39.0099 16.2197 38.7433 16.8585L33.166 30.1731H37.0697L37.8446 28.0274H42.6128L43.0629 30.1731ZM33.3596 25.4825C33.3757 21.6907 28.1177 21.4806 28.1529 19.7863C28.1642 19.2715 28.6554 18.7231 29.729 18.5829C30.2612 18.5144 31.7299 18.4588 33.3948 19.226L34.046 16.178C33.1518 15.8545 32.0011 15.543 30.5692 15.543C26.8946 15.543 24.3097 17.4948 24.289 20.292C24.2654 22.3605 26.1355 23.5139 27.5415 24.2028C28.9912 24.907 29.4769 25.3584 29.4698 25.9876C29.4598 26.9516 28.3139 27.3785 27.2468 27.3946C25.377 27.4237 24.2932 26.8892 23.4294 26.4866L22.7546 29.6364C23.6246 30.0345 25.2274 30.3809 26.8871 30.3987C30.7937 30.3987 33.348 28.4698 33.3596 25.4825ZM17.9649 15.8054L11.9422 30.1731H8.01365L5.04969 18.7066C4.87001 18.0015 4.71328 17.7424 4.16683 17.4444C3.27299 16.959 1.79746 16.505 0.5 16.2226L0.587899 15.8054H6.91267C7.71829 15.8054 8.44312 16.3415 8.62765 17.2696L10.1933 25.5843L14.0599 15.8054H17.9649Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.faaa1ee577990110be22c5f60f0f86b9.svg";
export { ForwardRef as ReactComponent };